/** Same sectioning as the server's split_sections, so section_index lines up with /lyrics/refine. */
export function splitSections(lyrics = "") {
  const sections = [];
  let current = { header: null, lines: [] };
  const close = () => {
    const lines = [...current.lines];
    while (lines.length && !lines[0].trim()) lines.shift();
    while (lines.length && !lines[lines.length - 1].trim()) lines.pop();
    if (current.header !== null || lines.length) sections.push({ header: current.header, lines });
  };
  for (const ln of lyrics.split(/\r?\n/)) {
    const m = ln.match(/^\s*\[(.+?)\]\s*$/);
    if (m) { close(); current = { header: m[1].trim(), lines: [] }; } else current.lines.push(ln.replace(/\s+$/, ""));
  }
  close();
  return sections;
}

export const isChorus = (header = "") => /chorus|hook/i.test(header) && !/pre/i.test(header);
